<template>
  <SkeletonPulse>
    <div class="expert-card-skeleton">
      <div class="expert-card-skeleton__mobile-date mq-mobile-only">
        <SkeletonShape width="90px" height="14px" />
      </div>
      <div class="expert-card-skeleton__aside">
        <SkeletonShape width="50px" height="50px" border-radius="50px" />
      </div>
      <div class="expert-card-skeleton__main">
        <div class="expert-card-skeleton__date mq-not-mobile">
          <SkeletonShape width="115px" height="12px" />
        </div>
        <div class="expert-card-skeleton__content">
          <div class="expert-card-skeleton__header">
            <!-- name -->
            <div class="expert-card-skeleton__title">
              <SkeletonLine width="150px" />
            </div>
            <!-- exp -->
            <div class="expert-card-skeleton__experience">
              <SkeletonLine width="160px" />
            </div>
            <!-- company -->
            <div class="expert-card-skeleton__experience">
              <SkeletonLine width="230px" />
            </div>
          </div>
          <!-- stats -->
          <div class="expert-card-skeleton__stats">
            <div class="expert-card-skeleton__connections">
              <SkeletonShape width="18px" height="18px" border-radius="9px" />
              <SkeletonLine width="106px" />
            </div>
            <div class="expert-card-skeleton__score">
              <SkeletonShape width="18px" height="18px" border-radius="9px" />
              <SkeletonLine width="74px" />
            </div>
          </div>
          <!-- help -->
          <SkeletonLine
            class="expert-card-skeleton__help-title"
            width="90px"
          />
          <SectionGroup gap="medium-large">
            <SectionGroup gap="smallest">
              <!-- qual -->
              <SkeletonLine width="220px" />
              <!-- spec -->
              <SkeletonLine width="300px" />
            </SectionGroup>
            <!-- skills -->
            <div class="expert-card-skeleton__help">
              <SkeletonLine width="240px" />
            </div>
            <!-- requests -->
            <SectionGroup gap="smallest">
              <SkeletonLine width="220px" />
              <SkeletonLine width="270px" />
            </SectionGroup>
          </SectionGroup>
        
        </div>
        <div class="expert-card-skeleton__footer">
          <SkeletonShape
            width="120px"
            height="27px"
          />
          <SkeletonShape
            v-if="mediaQueries.mobile"
            width="102px"
            height="36px"
          />
          <SkeletonShape
            v-else
            width="81px"
            height="30px"
          />
        </div>
      </div>
    </div>
  </SkeletonPulse>
</template>

<script>
  import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';
  import SkeletonLine from 'src/components/SkeletonLine/SkeletonLine.vue';
  import SkeletonPulse from 'src/components/SkeletonPulse/SkeletonPulse.vue';
  import SkeletonShape from 'src/components/SkeletonShape/SkeletonShape.vue';

  export default {
    name: 'ExpertCardSkeleton',
    components: {
      SectionGroup,
      SkeletonLine,
      SkeletonPulse,
      SkeletonShape
    },
    inject: [
      'mediaQueries',
    ],
  };
</script>